function shareableLinkFeature () {
    var $btn;
    var $linkInput;
    var $copyLinkContainer;
    var $linkStatus;
    var isSharedConfigPage = window.location.href.indexOf('?sharedProductConfig=') > -1;
    // window.tbg && window.tbg.productConfigService ? window.tbg.productConfigService : null
    const productConfigService = window.tbg && window.tbg.productConfigService ? window.tbg.productConfigService : null;
    window.configureEvents.registerOnCalcLoadedListener({ onCalcLoaded: init });
    init();

    function init () {
        setupDOM();
        enableHandlers();

        function setupDOM () {
            $('.js--element-generalCalculator').after('<div class="shareLinkConfig"><button id="js-shareLinkConfigTrigger" class="link link_iconShare shareLinkConfig-btn">share configuration</button><div class="shareLinkConfig-status"></div></div>');
            $copyLinkContainer = $('.shareLinkConfig_linkContainer');
            $btn = $('#js-shareLinkConfigTrigger');
            $linkInput = $('.js-configInput');
            $linkStatus = $btn.siblings('.shareLinkConfig-status');

            isSharedConfigPage && updateConfiguredStatus({ status: true });
        }

        function enableHandlers () {
            window.configureEvents.registerOnCalcChangedListener({ onCalcChanged: handleCalcChanged });
            $btn.on('click', handleButtonClick);
            $('.js-linkCopyBtn').on('click', copyLinkButtonClick);
        }
    }

    function handleButtonClick () {
        if ($btn.hasClass('loading')) {
            return;
        }

        $btn.addClass('loading');

        getShareableLink().always(function(){
            $btn.removeClass('loading');
        });
    }

    function removeQueryString () {
        if (history.pushState) {
            var urlWithoutQuery = window.location.href.split('?')[0];
            window.history.pushState({ path: urlWithoutQuery },'', urlWithoutQuery);
        }
    }

    function setStylesSelectedIndex () {
        if (!document.querySelector('.js-action--productConfigSelect')) {
            return;
        }

        document.querySelector('.js-action--productConfigSelect').selectedIndex = 0;
    }

    function handleCalcChanged () {
        if (isSharedConfigPage) {
            removeQueryString();
            setStylesSelectedIndex();
        }

        updateConfiguredStatus({ changed: true });
    }

    function updateConfiguredStatus (options) {
        if (isSharedConfigPage && !options.copied && !options.changed) {
            $linkStatus.text('Saved Configuration');
        }

        if (options.status || options.error || options.copied) {
            $linkStatus.addClass('hasStatusMessage');
        }

        if (options.copied) {
            $linkStatus.text('Copied to clipboard');
            $copyLinkContainer.addClass('linkCopiedToClipboard');
        }

        if (options.changed) {
            $linkStatus.text('Configration Changed');
            $copyLinkContainer.removeClass('linkCopiedToClipboard');
        }
        if (options.error) {
            $linkStatus.text('Error, please try again');
        }
    }

    function getShareableLink () {
        return productConfigService.getShareableLink(successCb, errorCb);

        function successCb (link) {
            $linkInput.val(link);

            // TODO: Refactor BodyLock function and inplement here
            $('body').addClass('mix-bodyIsLocked');
            $('#shareConfigDialog').addClass('modal_isActive');
        }

        function errorCb () {
            updateConfiguredStatus({ error: true });
        }
    }

    function copyLinkButtonClick () {
        copyStringToClipboard($linkInput.val());

        updateConfiguredStatus({ copied: true });
    }

    function copyStringToClipboard (str) {
        var el = $linkInput.get(0);
        el.value = str;
        el.setAttribute('readonly', ''); // Set non-editable to avoid focus
        selectText();
        document.execCommand('copy');

        return;

        function selectText () {
            var range;
            var selection;
            // if iOS
            if (navigator.userAgent.match(/ipad|iphone/i)) {
                range = document.createRange();
                range.selectNodeContents(el);
                selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
                el.setSelectionRange(0, 999999);
            } else {
                el.select();
            }
        }
    }
}
export default shareableLinkFeature;